<template>
  <div class="locale-changer">
    <span v-for="(lang, i) in langs" :key="`Lang${i}`">
      <span
        :value="lang"
        :class="{ active: lang == store.state.language }"
        @click="changeLang(lang)"
        class="click-lang"
      >
        {{ lang }}<span v-if="i != langs.length - 1">/</span>
      </span>
    </span>
  </div>
</template>

<style lang="scss" scoped>
.click-lang {
  cursor: pointer;
  text-transform: uppercase;
  color: #ffffff;

  &.active {
    font-weight: bold;
  }
}
</style>

<script>
import langs from "@/lang";
import { provide } from "vue";
import store from "@/store";

export default {
  name: "locale-changer",
  data: () => ({
    store,
    langs: Object.keys(langs)
  }),
  setup() {
    provide("store", store);
  },
  methods: {
    changeLang: function(lang) {
      this.$root.$i18n.locale = lang;
      store.methods.switchLanguage(lang);
      this.$primevue.config.locale.emptyMessage = "No available options";
      if (lang == "de") {
        this.$primevue.config.locale.emptyMessage = "Keine Auswahl vorhanden";
      }
    }
  }
};
</script>
